import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import Vue from 'vue';
import store from '@/store';
import { getAsync, postAsync, patchAsync, deleteAsync } from '@/rpcutil';
import { CompanyPaymentMethod } from '@/store/CompanyStore';
import { structuralEquals } from '@/util';

export enum ConsoleType {
    Unknown = 0,
    Gen1 = 1,
    Gen2 = 2,
}
export interface Console {
    id: number,
    dispId: string,
    registeredOn: Date,
    type: ConsoleType,
    remarks?: string,
}

export interface ConsoleDetail extends Console {
    rentalCompanyId?: string,
    rentalCompanyName?: string,
}

export interface ConsoleSearchOption {
    year: number,
    month: number,
    paymentMethod?: CompanyPaymentMethod,
    processed?: boolean,
    notProcessed?: boolean,
}

function objectize(val: Console) {
    val.registeredOn = new Date(val.registeredOn);
}

@Module({ name: 'console', namespaced: true, dynamic: true, store: store })
class ConsoleStore extends VuexModule {
    details: ConsoleDetail[] = [];

    @Mutation
    UPDATE_DETAILS(vals: ConsoleDetail[]) {
        for(let i = 0; i < vals.length; i++) {
            Vue.set(this.details, i, vals[i]);
            // this.detail_status_map[val[i].sid] = i;
        }
        const delete_count = this.details.length - vals.length;
        for(let i = 0; i < delete_count; i++) {
            Vue.delete(this.details, vals.length);
        }
    }

    @Mutation
    UPDATE_DETAIL_PARTIAL({ id, val }: { id: number, val: Partial<ConsoleDetail> }) {
        const target = this.details.filter(x => x.id === id)[0];
        if(target !== undefined) {
            Vue.set(this.details, this.details.indexOf(target), { ...target, ...val });
        }
    }

    @Mutation
    UPDATE_DETAIL(val: ConsoleDetail) {
        const target = this.details.filter(x => x.id === val.id)[0];
        if(target !== undefined)
            Vue.set(this.details, this.details.indexOf(target), val);
        else
            Vue.set(this.details, this.details.length, val);
    }

    @Mutation
    REMOVE_DETAIL(id: number) {
        const target = this.details.filter(x => x.id === id)[0];
        if(target !== undefined)
            Vue.delete(this.details, this.details.indexOf(target));
    }

    @Action({ rawError: true })
    async updateRepository() {
        const res = await getAsync('/api/console');
        (res.data as ConsoleDetail[]).map(x => objectize(x));
        this.UPDATE_DETAILS(res.data);
    }

    @Action({ rawError: true })
    async get(): Promise<any> {
        await this.updateRepository();
        return this.details;
    }

    @Action({ rawError: true })
    async create(console: ConsoleDetail): Promise<ConsoleDetail> {
        const res = await postAsync('/api/console', console);
        const data = res.data as ConsoleDetail;
        objectize(data);
        this.UPDATE_DETAIL(data);
        return data;
    }

    @Action({ rawError: true })
    async delete(id: number) {
        const res = await deleteAsync('/api/console/' + id);
        this.REMOVE_DETAIL(id);
    }

    @Action({ rawError: true })
    async modify({ id, mods }: { id: number, mods: Partial<ConsoleDetail> }) {
        if(Object.keys(mods).length > 0) {
            // send
            const result = await patchAsync('/api/console/' + id, mods);
            if(result.data.result == "ok") {
                // apply locally
                this.UPDATE_DETAIL_PARTIAL({ id, val: mods });
                return true;
            }
            else
                return false;
        }
    }
}

export default getModule(ConsoleStore);
